import React from 'react';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BookingCTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 10, bgcolor: 'background.default' }}>
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.light} 100%)`,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h3"
            component="h2"
            sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}
          >
            {t('bookingCTA.title')}
          </Typography>
          <Typography
            variant="h6"
            component="p"
            sx={{ mb: 4, maxWidth: 600, mx: 'auto', color: 'text.primary' }}
          >
            {t('bookingCTA.subtitle')}
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            color="primary"
            size="large"
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: 'text.primary',
              boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1)',
            }}
          >
            {t('bookingCTA.button')}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default BookingCTA;
